import { Controller } from "@hotwired/stimulus";
import consumer from "../channels/consumer";

// Subscribes to FeedbackChannel for a single feedback thread and appends
// incoming messages to the DOM live (used on the admin feedback show page).
export default class extends Controller {
  static targets = ["thread", "form", "input", "submit"];
  static values = { feedbackId: Number };

  connect() {
    this.subscription = consumer.subscriptions.create(
      { channel: "FeedbackChannel", feedback_id: this.feedbackIdValue },
      { received: (data) => this.appendMessage(data) },
    );
  }

  disconnect() {
    if (this.subscription) {
      consumer.subscriptions.remove(this.subscription);
      this.subscription = null;
    }
  }

  // Submits the reply form over fetch instead of a normal navigation, so the
  // page (and the live-updating thread above it) never reloads. The sent
  // message itself isn't appended here — it arrives back through the same
  // ActionCable broadcast every subscriber gets, including this page.
  async sendMessage(event) {
    event.preventDefault();
    if (!this.hasFormTarget || !this.hasInputTarget) return;

    const body = this.inputTarget.value.trim();
    if (!body) return;

    if (this.hasSubmitTarget) this.submitTarget.disabled = true;

    try {
      const response = await fetch(this.formTarget.action, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(this.formTarget),
      });

      if (response.ok) {
        this.inputTarget.value = "";
      } else {
        const data = await response.json().catch(() => ({}));
        alert(data.error || "Не вдалося надіслати повідомлення");
      }
    } catch (error) {
      alert("Не вдалося надіслати повідомлення. Перевірте з'єднання.");
    } finally {
      if (this.hasSubmitTarget) this.submitTarget.disabled = false;
    }
  }

  appendMessage(data) {
    if (!this.hasThreadTarget) return;

    const bubble = document.createElement("div");
    bubble.className = `d-flex mb-2 ${data.from_admin ? "justify-content-end" : "justify-content-start"}`;

    const content = document.createElement("div");
    content.className = `p-2 rounded ${data.from_admin ? "bg-primary text-white" : "bg-light"}`;
    content.style.maxWidth = "75%";

    const author = document.createElement("div");
    author.className = "small fw-semibold";
    author.textContent = data.author_name || "";

    const body = document.createElement("div");
    body.textContent = data.body;

    const timestamp = document.createElement("div");
    timestamp.className = `small ${data.from_admin ? "text-white-50" : "text-muted"}`;
    timestamp.textContent = data.created_at
      ? new Date(data.created_at).toLocaleString()
      : "";

    content.append(author, body, timestamp);
    bubble.append(content);
    this.threadTarget.append(bubble);
    this.threadTarget.scrollTop = this.threadTarget.scrollHeight;
  }
}
